import { render } from "./Calendar.vue?vue&type=template&id=a9ad127e&bindings={\"currentDate\":\"data\",\"currentMonth\":\"data\",\"currentYear\":\"data\",\"days\":\"data\",\"daysInMonth\":\"options\",\"startDay\":\"options\",\"next\":\"options\",\"prev\":\"options\",\"currenDateClass\":\"options\",\"currentMonthName\":\"options\"}"
import script from "./Calendar.vue?vue&type=script&lang=js"
export * from "./Calendar.vue?vue&type=script&lang=js"
script.render = render

export default script